import React from 'react'
import AutoSwipeBanner from './AutoSwipeBanner'
import StorySection from './StorySection'

const Banner = () => {

    return (
        <section className="header-banner w-full bg-yellow-50 min-h-[300px] sm:min-h-[350px] md:min-h-[400px] lg:min-h-96 flex flex-col justify-center py-3 sm:py-4 md:py-6 lg:py-8 pt-16 sm:pt-18 md:pt-20 lg:pt-24 xl:pt-10">
            {/* Auto Swipe Banner */}
            <div className="w-full flex justify-center items-center mb-4 sm:mb-6 md:mb-4 lg:mb-8 px-2 sm:px-3 md:px-4">
                <AutoSwipeBanner />
            </div>
            
            {/* Story Section */}
            <div className="w-full">
                <StorySection />
            </div>
        </section>
    )
}

export default Banner
